const theme = ({ palette: { grey = {}, form }, spacing: { unit }, typography = {} }) => ({
  formGroup: {
    borderRadius: 2
  },
  formControl: {
    padding: `${unit * 0.75}px ${unit * 1.25}px`,
    border: `1px solid ${form?.border}`,
    borderRadius: 2,
    // Hard coded to match the Flex Drop Down
    minHeight: 34
  },
  optionalLabel: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap'
  },
  label: {
    // Causing some issues on a few labels particularly sign on page.
    // May need to add since optionalLabel is display flex
    //    display: 'flex',
    fontWeight: typography.fontWeightHeavy,
    textTransform: 'uppercase',
    fontSize: 12,
    color: grey.G600
  },
  'input:not([type=checkbox]):not([type=radio])': {
    // Hard coded to match the Flex Drop Down
    minHeight: 34
  }
});

export default theme;
